import { useQuery } from '@tanstack/react-query';

import { callGetConversionRate } from '@app/client/resources/nft/nft';

type UseGetCurrencyConversionProps = {
    interval: boolean;
    customInterval?: number;
    disabled?: boolean;
    ids?: string;
    vs_currencies?: string;
};
export const useGetCurrencyConversion = ({
    customInterval,
    interval,
    disabled,
    ids = 'ethereum',
    vs_currencies = 'usd',
}: UseGetCurrencyConversionProps) => {
    const cache = [ids, vs_currencies];
    const refetchInterval = interval ? customInterval || 15000 : undefined;

    return useQuery(
        cache,
        ({ signal }) =>
            callGetConversionRate({
                query: {
                    ids,
                    vs_currencies,
                },
                settings: {
                    signal,
                },
            }),
        {
            refetchInterval,
            retry: false,
            enabled: !disabled,
        },
    );
};
